// Helpers de formatage pour l'app GestionCardex.

/**
 * Formate un nombre au format français-canadien avec espace comme séparateur
 * de milliers : 99999 → "99 999", 1234567 → "1 234 567".
 * Remplace l'espace insécable retourné par Intl par un espace classique
 * (plus prévisible pour les tests et le copier-coller).
 */
export const fmt = (n) =>
    Number(n ?? 0)
        .toLocaleString("fr-CA")
        .replace(/\u00A0/g, " ")
        .replace(/,/g, " ");

/**
 * Formate une date ISO (YYYY-MM-DDTHH:mm:ss) en format court fr-CA :
 *   "2026-06-23T17:59:20+00:00" → "2026-06-23"
 * Retourne "—" si la date est nulle/invalide.
 */
export const formatDateShort = (iso) => {
    if (!iso) return "—";
    const d = new Date(iso);
    if (Number.isNaN(d.getTime())) return "—";
    // YYYY-MM-DD (sans heure)
    const yyyy = d.getFullYear();
    const mm = String(d.getMonth() + 1).padStart(2, "0");
    const dd = String(d.getDate()).padStart(2, "0");
    return `${yyyy}-${mm}-${dd}`;
};
